/* tslint:disable */
/* eslint-disable */
/**
 * SBL API Glommen Mjøsen Skog
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const GMAzureIntegrationsCommonModelsEnumsAllmaActionType = {
    Flaterydding: 'Flaterydding',
    Spraying: 'Spraying',
    Stubbehandling: 'Stubbehandling',
    Markberedning: 'Markberedning',
    MarkberedningMedGravemaskin: 'MarkberedningMedGravemaskin',
    MarkberedningMedSaaing: 'MarkberedningMedSaaing',
    NaturligForyngelse: 'NaturligForyngelse',
    Saaing: 'Saaing',
    Planting: 'Planting',
    SpraytingEtterHogst1: 'SpraytingEtterHogst1',
    MarkberedningEtterHogst1: 'MarkberedningEtterHogst1',
    NaturligForyngelseEtterHogst1: 'NaturligForyngelseEtterHogst1',
    PlantingEtterHogst1: 'PlantingEtterHogst1',
    PlantingTreslagsblanding: 'PlantingTreslagsblanding',
    PlantingAvFuru: 'PlantingAvFuru',
    Treslagsskifte: 'Treslagsskifte',
    Suppleringsplanting: 'Suppleringsplanting',
    Plantefeltkontroll: 'Plantefeltkontroll',
    EttersynEventueltSuppleringsplanting: 'EttersynEventueltSuppleringsplanting',
    EttersynEventueltUngskogpleie: 'EttersynEventueltUngskogpleie',
    EttersynVurderBehovetForEtterarbeid: 'EttersynVurderBehovetForEtterarbeid',
    Grasrydding: 'Grasrydding',
    Gjenvekstpleie: 'Gjenvekstpleie',
    Lauvrydding: 'Lauvrydding',
    Avstandsregulering: 'Avstandsregulering',
    Ungskogpleie: 'Ungskogpleie',
    MaskinellUngskogpleie: 'MaskinellUngskogpleie',
    KunstigKvistning: 'KunstigKvistning',
    HogstAvOverstandere: 'HogstAvOverstandere',
    HogstAvFrotraer: 'HogstAvFrotraer',
    HogstAvSkjermtraer: 'HogstAvSkjermtraer',
    HogstAvLauvtraer: 'HogstAvLauvtraer',
    HogstAvBestandsrest: 'HogstAvBestandsrest',
    Forhandsrydding: 'Forhandsrydding',
    ReguleringIHogstklasse3: 'ReguleringIHogstklasse3',
    ForhandsryddingForTynning: 'ForhandsryddingForTynning',
    ForhandsryddingForSluttavvirkning: 'ForhandsryddingForSluttavvirkning',
    Tynning: 'Tynning',
    Vedhogst: 'Vedhogst',
    Gjennomhogst: 'Gjennomhogst',
    HogstAvSkaddeTraer: 'HogstAvSkaddeTraer',
    Heltrehogst: 'Heltrehogst',
    Flatehogst: 'Flatehogst',
    Smalatehogst: 'Smalatehogst',
    HogstAvEnkelttraerOgSmaflaater: 'HogstAvEnkelttraerOgSmaflaater',
    Frotrestillingshogst: 'Frotrestillingshogst',
    Tommerstillingshogst: 'Tommerstillingshogst',
    Skjermstillingshogst: 'Skjermstillingshogst',
    Bledningshogst: 'Bledningshogst',
    Fjellskoghogst: 'Fjellskoghogst',
    Plukkhogst: 'Plukkhogst',
    Hagnerhogst: 'Hagnerhogst',
    Gruppehogst: 'Gruppehogst',
    Kanthogst: 'Kanthogst',
    Stripehogst: 'Stripehogst',
    PlantingEtterHogst: 'PlantingEtterHogst',
    Graefting: 'Graefting',
    Suppleringsgraefting: 'Suppleringsgraefting',
    Graeftetrensk: 'Graeftetrensk',
    Gjodsling: 'Gjodsling',
    Sporsletting: 'Sporsletting',
    VelgTiltak: 'VelgTiltak',
    Plantesalg: 'Plantesalg'
} as const;

export type GMAzureIntegrationsCommonModelsEnumsAllmaActionType = typeof GMAzureIntegrationsCommonModelsEnumsAllmaActionType[keyof typeof GMAzureIntegrationsCommonModelsEnumsAllmaActionType];



